import { createDataLayer } from '@atlas/react-data-layer'

/**
 * To generate json schema for Adobe ContextHub
 * 1. Copy paste the JSON object here:
 * https://www.liquid-technologies.com/online-json-to-schema-converter
 * 2. Go to Adobe Launch > Extensions > ContextHub > Configure
 * 3. Press Open Editor
 * 4. Paste the schema into the editor and save/build
 * 5. IF YOU REMOVED ANY PROPERTY
 * > ensure that any "data elements" wired up to missing properties gets remapped.
 */

export const DataLayer = createDataLayer({
  site: {
    name: 'legoeducation',
    section: '',
  },
  page: {
    locale: '',
    events: '',
  },
  cart: {},
  login_status: 'not available',
  // new
  page_section: '',
  page_type: '',
  page_name: '',
  purchasing_as: '',
  purchase_id: '',
  order_payment_type: '',
  order_subtotal: '',
  order_shipping: '',
  order_tax: '',
  order_discount_code: '',
  order_discount_amount: '',
  search_term: '',
  search_results: '',
  search_area: '',
})
